import { render, staticRenderFns } from "./ProspectSearchScreen.vue?vue&type=template&id=56cdcb02&scoped=true&"
import script from "./ProspectSearchScreen.vue?vue&type=script&lang=ts&"
export * from "./ProspectSearchScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ProspectSearchScreen.vue?vue&type=style&index=0&id=56cdcb02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cdcb02",
  null
  
)

export default component.exports